/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentsRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model() {
    let store = this.store;
    let person = this.modelFor('people.person').person;
    return hash({
      person: person,
      assessments: store.findAll('assessments/assessment'),
      modules: store.findAll('assessments/module'),
      categories: store.findAll('assessments/category'),
      gradeschedules: store.findAll('assessments/grade-schedule'),
      grades: store.query('assessments/grade', { personId: person.id }),
    });
  }

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        // Set activeAssessment on the controller so that it can highlight the correct button.
        let assessmentId = this.paramsFor(
          'people.person.assessments.assessment',
        ).assessment_id;
        this.controller.set('activeAssessment', assessmentId);
      }
    });
  }
}
